import { useState, useEffect, useMemo } from 'react'
import { useApi } from '../../../shared/hooks/useApi';
import CustomTable from '../../../shared/components/table/custom-table';
import { MRT_ColumnDef } from 'material-react-table';
import { Box, Grid, Typography } from '@mui/material';
import { LoaderComponent } from '../../../shared/components/loaders/page-loader';
import { StyledButton } from '../../../shared/components/buttons/custom-button';
import { CustomSelect, CustomTextField } from '../../../shared/components/inputfields/form-elements';
import { ETCAppConfig } from '../../../shared/app-configs/etc-app-configs';
import { ITcCertifiedRawMaterialInformation, ITcStandardCertifiedWeightInformation, transformToRowData } from '../../etc/etc-models/Icertified-raw-material-std-model';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Utills } from '../../../shared/app-configs/utilit';

export default function CertifiedRawMaterialsStdDetails() {
    const [data, setData] = useState<any[]>([]);
      const { etcId, formtype } = useParams<string>()
    const [editingRowIndex, setEditingRowIndex] = useState<number>(-1);
    const { loading, executeGet} = useApi();
    const [getAPITcStandard, setAPITcStandard] = useState<any>([]);
    const [getTcStandardDetails, setTcStandardDetails] = useState<any>([]);
    const [getTcStandardCalc, setTcStandardCalc] = useState<any>([]);
    const [getTCStdWeightInfo, setTCStdWeightInfo] = useState({
    OCS: 0, GRS: 0, RCS: 0, RDS: 0, RWS: 0, RMS: 0, RAS: 0, CCS: 0, SFA: 0
    });
    const navigate = useNavigate();


    const columns: MRT_ColumnDef<any>[] = [
      {
          accessorKey: "tcStandard",
          header: "eTC Standard",
          enableHiding: false,
          minSize: 60, maxSize: 150
      },
      {
          accessorKey: "rawMaterialCode",
          header: "Certified Raw Material Code",
          enableHiding: false,
          minSize: 60, maxSize: 150
      },
      {
          accessorKey: "rawMaterialWeight",
          header: "Certified Raw Material Weight (kg)",
          enableHiding: false,
          minSize: 60, maxSize: 150
      },
      {
          accessorKey: "country",
          header: "Country",
          enableHiding: false,
          minSize: 60, maxSize: 150
      },
      {
          accessorKey: "state",
          header: "State",
          enableHiding: false,
          minSize: 60, maxSize: 150
      },
  ];
  const tcStandardDetails = [
    { label: "Organic Content Standard (OCS)", value: "OCS" },
    { label: "Responsible Down Standard (RDS)", value: "RDS" },
    { label: "Responsible Alpaca Standard (RAS)", value: "RAS" },
    { label: "Global Recycled Standard (GRS)", value: "GRS" },
    { label: "Responsible Wool Standard (RWS)", value: "RWS" },
    { label: "Content Claim Standard (CCS)", value: "CCS" },
    { label: "Recycled Claim Standard (RCS)", value: "RCS" },
    { label: "Responsible Mohair Standard (RMS)", value: "RMS" },
    { label: "Sustainable Fiber Alliance (SFA)", value: "SFA" },
  ]
  const standards = [
    { name: 'Organic Content Standard (OCS)', value: getTCStdWeightInfo.OCS, key: 'OCS' },
    { name: 'Global Recycled Standard (GRS)', value: getTCStdWeightInfo.GRS, key: 'GRS' },
    { name: 'Recycled Claim Standard (RCS)', value: getTCStdWeightInfo.RCS, key: 'RCS' },
    { name: 'Responsible Down Standard (RDS)', value: getTCStdWeightInfo.RDS, key: 'RDS' },
    { name: 'Responsible Wool Standard (RWS)', value: getTCStdWeightInfo.RWS, key: 'RWS' },
    { name: 'Responsible Mohair Standard (RMS)', value: getTCStdWeightInfo.RMS, key: 'RMS' },
    { name: 'Responsible Alpaca Standard (RAS)', value: getTCStdWeightInfo.RAS, key: 'RAS' },
    { name: 'Content Claim Standard (CCS)', value: getTCStdWeightInfo.CCS, key: 'CCS' },
    { name: 'Sustainable Fiber Alliance (SFA)', value: getTCStdWeightInfo.SFA, key: 'SFA' },
  ];
  const mapPayLoad = (data: any[]): ITcStandardCertifiedWeightInformation[] => {
    const tcStandardCertifiedWeightInformationData: ITcStandardCertifiedWeightInformation[] = [];

    data.forEach((row) => {
      const existingEntry = tcStandardCertifiedWeightInformationData.find(
        (entry) => entry.tcStandard === row.tcStandard
      );

      const rawMaterialInfo: ITcCertifiedRawMaterialInformation = {
        tcCertifiedRawMaterialCode: row.rawMaterialCode,
        tcCertifiedRawMaterialWeight: parseFloat(row.rawMaterialWeight),
        tcCertifiedRawMaterialCountryOrArea: row.country,
        tcCertifiedRawMaterialStateOrProvince: row.state,
      };

      if (existingEntry) {
        //(`existingEntry.tcCertifiedWeight ${existingEntry.tcCertifiedWeight}`)
        existingEntry.tcCertifiedWeight += parseFloat(row.rawMaterialWeight);
        existingEntry.tcCertifiedRawMaterialInformation.push(rawMaterialInfo);
      } else {
        //(`newentry.tcCertifiedWeight ${row.rawMaterialWeight}`)
        // Create a new entry
        tcStandardCertifiedWeightInformationData.push({
          tcStandard: row.tcStandard,
          tcCertifiedWeight: parseFloat(row.rawMaterialWeight),
          tcCertifiedRawMaterialInformation: [rawMaterialInfo],
        });
      }
    });

    return tcStandardCertifiedWeightInformationData;
  }
  const sumWeight = (data: any[], standard: string) => {
    //('Filtering for standard: ', standard); // Debug log for standard
    const weightSum = data
      .filter(m => m.tcStandard.toLowerCase() === standard.toLowerCase()) // Filter by tcStandard
      .reduce((sum, current) => {
        //('Adding weights for row: ', current); // Debug log for row data

        // Sum up tcCertifiedRawMaterialWeight for all raw materials
        const rowWeightSum = current.tcCertifiedRawMaterialInformation.reduce(
          (rowSum: any, rawMaterial: any) => rowSum + (isNaN(rawMaterial.tcCertifiedRawMaterialWeight) ? 0 : rawMaterial.tcCertifiedRawMaterialWeight),
          0
        );

        return sum + rowWeightSum;
      }, 0);

    //(`Total weight for ${standard}: `, weightSum); // Debug log for total weight
    return weightSum;
  };

  const calculateTCStdSummaryWeight = (data: any) => {
      const getWeightInfo: any = mapPayLoad(data)
      setTCStdWeightInfo({
        CCS: sumWeight(getWeightInfo, 'ccs'),
        GRS: sumWeight(getWeightInfo, 'grs'),
        OCS: sumWeight(getWeightInfo, 'ocs'),
        RAS: sumWeight(getWeightInfo, 'ras'),
        RCS: sumWeight(getWeightInfo, 'rcs'),
        RDS: sumWeight(getWeightInfo, 'rds'),
        RMS: sumWeight(getWeightInfo, 'rms'),
        RWS: sumWeight(getWeightInfo, 'rws'),
        SFA: sumWeight(getWeightInfo, 'sfa'),
      });
    }
    useMemo(() => calculateTCStdSummaryWeight(data), [data]);
  const fetchStandardDetails = async () => {
    const response: any = await executeGet(ETCAppConfig.GET_ETC_BASE_DETAILS, {  etcId: etcId });
    if (response?.data) {
      setAPITcStandard(response?.data?.tcStandard)
      const selectedRecords = tcStandardDetails.filter(item => response?.data?.tcStandard.includes(item.value));
      const calcRecords = standards.filter(item =>
        response?.data?.tcStandard.includes(item.key)
      )
      setTcStandardDetails(selectedRecords)
      setTcStandardCalc(calcRecords)
      console.log(`getTcStandardCalc ${JSON.stringify(getTcStandardCalc)}`)
    }
  }
    const fetchProductWeightDetails = async () => {
        try {
          const response: any = await executeGet(ETCAppConfig.GET_CERTIFIED_WEIGHT_INFO, { etcId: etcId });
          Utills.cl("response", response)
          const data = transformToRowData(response.data);
          Utills.cl(data)
          setData(data)
        } catch (err) {
          console.error('Failed to fetch Certified Raw Materials and Standard Details:', err);
        }
      };

      const handleSubmit = () => {
        navigate(`/etc/${formtype}/etc-components-details/${etcId}`)
      };
      
      useEffect(() => {
        fetchProductWeightDetails();
        fetchStandardDetails();
      }, []);
  
  
    return (

        <>
          {loading ? <LoaderComponent /> : <div>
            <Typography fontWeight={"600"}>Summary of TC Standard Certified Weight</Typography>
            <Box sx={{ width: '100%', textAlign: 'left', mb: 3 }} display="grid">
             
              <Box component="main" sx={{ flexGrow: 1, p: 1, border: '2px solid rgba(128, 128, 128, .2)', my: 4 }}>
              <Grid container spacing={2}>
                {standards.filter(item =>
                getAPITcStandard.includes(item.key)
              ).map((standard, index) => (
                  <Grid item xs={12} sm={4} key={index}>
                    <Typography>
                      {standard.name} : {standard.value}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>
            <CustomTable
                data={data}
                columns={columns}
                enableTopToolbar={false}
                enableBottomToolbar={true}
              />
            </Box>
          </div>}
          <Box sx={{
                          display: "flex", justifyContent: "flex-end", mt: 2
                        }}>
                          <StyledButton variant="contained" onClick={handleSubmit}>
                            Next
                          </StyledButton>
                          <NavLink to="/tc-dashboard">
                            <StyledButton variant="contained">
                              Cancel
                            </StyledButton>
                          </NavLink>
                        </Box>
        </>
    
      );
}